(async (w: Window) => {
    if (!w.Inpl?.Ad?.instanced) {
        w.Inpl = w.Inpl || { Ad: {} };
        w.Inpl.Ad = { ...w.Inpl.Ad, instanced: true, plugins: w.Inpl.Ad?.plugins || {} };
        const app = await import('./core/pre-config/pre-config');
        await app.default();
    }
})(window);
